// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import { Context } from "@opentelemetry/api";
import { ReadableSpan, Span, SpanProcessor } from "@opentelemetry/sdk-trace-web";
import { _getItemFromLocal } from "../Utils/Helpers/LocalKeys";
import { _getItemFromLocalDecrypted } from "network-helper";
import _ from "lodash";
export class SessionIdProcessor implements SpanProcessor {
    forceFlush(): Promise<void> {
        return Promise.resolve();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onStart(span: Span, parentContext: Context): void {

        const primaryProfile = JSON.parse(_getItemFromLocalDecrypted("_pp"));
        const currentProfile = JSON.parse(_getItemFromLocalDecrypted("_cp"))
        const jhhID = _.get(currentProfile,"jio_id")
        const sessionID = _getItemFromLocal("_t");
        const primaryJHH_ID =  _.get(primaryProfile,"jio_id")
        span.setAttribute('userId', jhhID || 'Guest User');
        span.setAttribute('sessionId', sessionID || 'Guest Session');
        span.setAttribute('primaryUserID', primaryJHH_ID || 'Primary Guest User');
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    onEnd(span: ReadableSpan): void {}

    shutdown(): Promise<void> {
        return Promise.resolve();
    }
}
